import styled from 'styled-components';

export const StyledAccordion = styled.div`
  margin-bottom: 30px;
  line-height: 1.4;

  > :last-child {
    margin-bottom: 0;
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  ${({ color }) => `color: ${color};`};

  > h3 {
    margin: 0;
    margin-left: 20px;
  }

  > i {
    font-size: 24px;
  }
`;
